import React from "react";
import Frame432 from "../Frame432";
import "./FAQ2False.css";

function FAQ2False(props) {
  const { className, frame432Props } = props;

  return (
    <div className={`faq2 ${className || ""}`}>
      <Frame432 line36={frame432Props.line36} className={frame432Props.className} />
    </div>
  );
}

export default FAQ2False;
